import { IconProps } from "./icon.type";

export function IcSidebarGroupManagementActive({ ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      {...props}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M15.4 18.0994C15.4 16.1898 14.6414 14.3585 13.2911 13.0082C11.9409 11.658 10.1095 10.8994 8.19998 10.8994M8.19998 10.8994C6.29043 10.8994 4.45908 11.658 3.10883 13.0082C1.75857 14.3585 1 16.1898 1 18.0994M8.19998 10.8994C10.6853 10.8994 12.7 8.88468 12.7 6.3994C12.7 3.91413 10.6853 1.89941 8.19998 1.89941C5.71471 1.89941 3.69999 3.91413 3.69999 6.3994C3.69999 8.88468 5.71471 10.8994 8.19998 10.8994ZM19 17.1993C19 14.1663 17.2 11.3493 15.4 9.99935C15.9917 9.55544 16.4648 8.97253 16.7775 8.3022C17.0902 7.63186 17.2329 6.89478 17.1928 6.15618C17.1528 5.41758 16.9313 4.70024 16.5479 4.06764C16.1646 3.43505 15.6312 2.9067 14.995 2.52937"
        stroke="#00152C"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
